import { Component } from 'react';
import { Content } from './shared/Content';
import { Attachments } from './shared/Attachments';
import { VisualAttachments } from './shared/VisualAttachments';
import { Kudo } from './shared/Kudo';
import { ShareContentObjectRenderer } from './ShareContentObjectRenderer';
import { ReadMore } from 'ui';

const PADDING = 20;

export class Renderer extends Component {
  render() {
    const { item, isBookmark, isOnFeed } = this.props;

    const postBody = (
      <>
        <Kudo item={item} />
        <Content item={item} />

        <div style={{ paddingLeft: PADDING, paddingRight: PADDING, display: 'inline-block', width: '100%' }}>
          <Attachments item={item} />

          {item.shared_content_object && (
            <blockquote className="renderer-core__blockquote">
              <ShareContentObjectRenderer
                item={item.shared_content_object}
                viewer={this.props.viewer}
              />
            </blockquote>
          )}
        </div>
      </>
    );

    return (
      <>
        <VisualAttachments item={item} />

        <div className="renderer-core">
          {isOnFeed ? <ReadMore>{postBody}</ReadMore> : postBody}
        </div>
      </>
    );
  }
}

export const PostRendererCore = Renderer;
